const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_minimal/settings/members/onboarding/preview.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { checkIfProtectedRouteCanBeSeen } from "@/react/components/shared/ProtectedRoute/useProtectedRoute";
import { planSettingsPath } from "@/react/helpers/urlHelpers";
export const Route = createFileRoute("/_minimal/settings/members/onboarding/preview")({
  beforeLoad: ({
    context,
    location
  }) => {
    const currentCommunity = context.punditUserContext?.currentCommunity;
    const canSeeProtectedRoute = checkIfProtectedRouteCanBeSeen(location.pathname, currentCommunity);
    if (!canSeeProtectedRoute) {
      redirect({
        to: planSettingsPath(),
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});